
import { Mixins, Component, Prop, Ref } from "vue-property-decorator";
import { CTAButton, ParallaxGallery, WYSIWYG } from "_components";
import { GSAP } from "_core";
import { HomePageHeroSectionType } from "../../types";
import HeroHeadline from "./Headline.vue";

@Component({
  name: "HomeHero",
  components: {
    CTAButton,
    HeroHeadline,
    ParallaxGallery,
    WYSIWYG,
  },
})
export default class HomeHero extends Mixins() {
  @Prop({ required: true }) heroData: HomePageHeroSectionType;

  @Ref() headlineRef: HeroHeadline;
  @Ref() imageRef: HTMLElement;
  @Ref() contentRef: HTMLElement;

  rootClass = "c-home-hero";
  private tl: gsap.core.Timeline;

  mounted() {
    this.animate();
  }

  animate() {
    const elementsToAnimate = [];
    if (this.headlineRef.$el) elementsToAnimate.push(this.headlineRef.$el);
    if (this.imageRef) elementsToAnimate.push(this.imageRef);
    if (this.contentRef) elementsToAnimate.push(this.contentRef);

    if (elementsToAnimate.length) {
      this.tl = GSAP.timeline();
      this.tl.fromTo(
        elementsToAnimate,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.75,
          stagger: 0.15,
          onComplete: () => {
            this.tl.kill();
            this.$emit("animated");
          },
        }
      );
    }
  }

  get headline() {
    const { top_line, bottom_line } = this.heroData.text.headline;
    return [top_line, bottom_line];
  }

  get images() {
    return this.heroData.images;
  }

  get bodyText() {
    return this.heroData.text.body_text && this.heroData.text.body_text;
  }

  get link() {
    return this.heroData.link_settings.link;
  }
}
